module.exports = __webpack_public_path__ + "media/src/images/icon/carousel-control-prev-1b9ad887a79bb6f4c4d5b729931b1257.svg";